import React, { useState, useEffect } from 'react'
import useStore from 'store'
import { getVolunteer } from 'servers/home'
import { InputNumber, Input, Select } from 'antd'
import Triangle from 'components/Triangle'
import VolunteerModal from 'components/VolunteerModal'
import edit from 'pages/PerCenter/images/edit.png'
import AfterVolunteer from './components/AfterVolunteer'
import s from './index.module.less'

const VolunMessage: React.FC<{}> = () => {
  const { state, dispatch } = useStore()
  const [subjectValue, setSubjectValue] = useState<string | undefined>('') // 选科input框
  const [canSubumit] = useState(false) // 是否可提交
  const [modalVisible, setModalVisible] = useState(false)
  const [volData, setVolData] = useState({
    // 高考省份
    gkProvince: state.volunteerData?.gkProvince,
    // 高考总分
    gkTotalScore: state.volunteerData?.gkTotalScore,
    // 全省排名
    rank: undefined,
    // 第一种模式 3+1+2
    volunteerTemplateFirstDto: {
      // 是否选择物理
      physics: false,
      // 是否选择历史
      history: false,
      // 是否选择化学
      chemistry: false,
      // 是否选择生物
      biology: false,
      // 是否选择政治
      politics: false,
      // 是否选择地理
      geography: false
    },
    // 第二种模式 3+3
    volunteerTemplateSecondDto: {
      physics: false,
      chemistry: false,
      biology: false,
      politics: false,
      history: false,
      geography: false,
      technology: false // 浙江有这个字段 技术
    },
    // 第三种模式 文理科
    volunteerTemplateThirdDto: {
      // 文理科类型 1文科 2理科
      subjectType: undefined
    }
  })

  const getVolunteerFun = () => {
    getVolunteer().then((res) => {
      if (res.code === 0) {
        dispatch({ type: 'updateVolunteer', payload: res.data })
      }
    })
  }

  useEffect(() => {
    if (state.userInfo?.id) {
      getVolunteerFun()
    }
  }, [state.userInfo?.id])

  useEffect(() => {
    // 有默认高考信息的回填
    if (state.volunteerData) {
      const {
        gkProvince,
        gkTotalScore,
        projectTypeStr,
        volunteerTemplateFirstDto,
        volunteerTemplateSecondDto,
        volunteerTemplateThirdDto
      } = state.volunteerData
      if (gkProvince || gkTotalScore || projectTypeStr) {
        let payload
        if (gkProvince || gkTotalScore) {
          payload = {
            ...volData,
            gkProvince,
            gkTotalScore
          }
        }
        if (projectTypeStr) {
          setSubjectValue(projectTypeStr)
          payload = {
            ...volData,
            gkProvince,
            gkTotalScore
          }
          if (volunteerTemplateFirstDto) {
            payload.volunteerTemplateFirstDto = volunteerTemplateFirstDto
          }
          if (volunteerTemplateSecondDto) {
            payload.volunteerTemplateSecondDto = volunteerTemplateSecondDto
          }
          if (volunteerTemplateThirdDto) {
            payload.volunteerTemplateThirdDto = volunteerTemplateThirdDto
          }
        }
        setVolData(payload)
      }
    }
  }, [state.volunteerData])

  return (
    <>
      <section className={s.VolunMessage}>
        <p className={s.title}>
          模拟高考志愿填报
          {state.volunteerData && (
            <button type="button" className={s.edit} onClick={() => setModalVisible(true)}>
              <img src={edit} alt="change" />
            </button>
          )}
        </p>
        <p className={s.des}>输入成绩信息，为您精准推荐</p>
        {/* 确认省份+已选科，则展示，否则可选 */}
        {/* 若高考省份为空，则点击三个字段均触发【基本信息、高考信息二合一弹窗】 */}
        {/* 若高考省份不为空，则显示为不可修改状态，选科、成绩可正常输入，三个字段均不为空时候【确定】按钮点亮 */}
        {state.volunteerData?.isSelectCourse && state.volunteerData.gkTotalScore ? (
          <section className={s.msgBox}>
            <AfterVolunteer />
          </section>
        ) : (
          <section className={s.msgBox}>
            {(!state.userInfo?.id ||
              !state.volunteerData ||
              !state.volunteerData.gkTotalScore ||
              !state.volunteerData.isSelectCourse) && (
              <button
                className={s.notLogin}
                type="button"
                aria-label="cant"
                onClick={() => {
                  if (!state.userInfo?.id) {
                    dispatch({ type: 'updateLoginModel', payload: true })
                    return
                  }
                  if (state.userInfo?.id && !state.volunteerData) {
                    dispatch({ type: 'updatePersoninfoModel', payload: true })
                    return
                  }
                  if (!state?.volunteerData?.gkTotalScore || !state.volunteerData.isSelectCourse) {
                    setModalVisible(true)
                  }
                }}
              />
            )}
            <section className={s.volBox}>
              <Select
                placeholder="请选择高考省份"
                value={state.volunteerData?.gkProvince}
                disabled
              />
            </section>
            <section className={s.volBox}>
              <Input placeholder="请选择高考科目" value={subjectValue} />
              <span className={s.triangle}>
                <Triangle width={6} direction="down" />
              </span>
            </section>
            <section className={s.volBox}>
              <InputNumber placeholder="请输入预估高考分数" value={volData.gkTotalScore} />
            </section>
          </section>
        )}
        {(!state.volunteerData?.isSelectCourse || !state.volunteerData.gkTotalScore) && (
          <button type="button" className={`${s.sure} ${!canSubumit && s.canSubmit}`}>
            确定
          </button>
        )}
      </section>
      <VolunteerModal
        visible={modalVisible}
        value={state.volunteerData}
        onCancel={() => setModalVisible(false)}
      />
    </>
  )
}

export default VolunMessage
